import { render, staticRenderFns } from "./DialogoBuscarParceiros.vue?vue&type=template&id=bdcd1e08&scoped=true&"
import script from "./DialogoBuscarParceiros.vue?vue&type=script&lang=js&"
export * from "./DialogoBuscarParceiros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcd1e08",
  null
  
)

export default component.exports